"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cleanProps = _interopRequireDefault(require("../utils/cleanProps"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Input =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Input, _PureComponent);

  function Input(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Input.prototype;

  _proto.invalidNumber = function invalidNumber(value) {
    var _this$props = this.props,
        digits = _this$props.digits,
        type = _this$props.type;
    if (type !== 'number') return false;
    var reg = '^-?\\d*';

    if (digits === undefined) {
      reg += '\\.?\\d*';
    } else if (digits > 0) {
      reg += "\\.?\\d{0," + digits + "}";
    }

    reg += '$';
    reg = new RegExp(reg);
    return !reg.test(value);
  };

  _proto.handleChange = function handleChange(e) {
    var value = e.target.value;
    if (this.invalidNumber(value)) return;
    this.props.onChange(value);
  };

  _proto.handleKeyUp = function handleKeyUp(e) {
    var _this$props2 = this.props,
        onKeyUp = _this$props2.onKeyUp,
        onEnterPress = _this$props2.onEnterPress;

    if (e.keyCode === 13 && onEnterPress) {
      onEnterPress(e.target.value, e);
    }

    if (onKeyUp) onKeyUp(e);
  };

  _proto.handleBlur = function handleBlur(e) {
    var value = e.target.value;
    var _this$props3 = this.props,
        forceChange = _this$props3.forceChange,
        onBlur = _this$props3.onBlur;
    if (onBlur) onBlur(e);
    if (this.invalidNumber(value)) return;
    if (forceChange) forceChange(value);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        type = _this$props4.type,
        defaultValue = _this$props4.defaultValue,
        digits = _this$props4.digits,
        className = _this$props4.className,
        htmlName = _this$props4.htmlName,
        forceChange = _this$props4.forceChange,
        onEnterPress = _this$props4.onEnterPress,
        other = _objectWithoutPropertiesLoose(_this$props4, ["type", "defaultValue", "digits", "className", "htmlName", "forceChange", "onEnterPress"]);

    var value = this.props.value == null ? '' : this.props.value;
    return _react.default.createElement("input", _extends({}, (0, _cleanProps.default)(other), {
      className: className,
      name: other.name || htmlName,
      type: type === 'password' ? type : 'text',
      value: value,
      onChange: this.handleChange,
      onKeyUp: this.handleKeyUp,
      onBlur: this.handleBlur
    }));
  };

  return Input;
}(_react.PureComponent);

Input.propTypes = {
  className: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  digits: _propTypes.default.number,
  forceChange: _propTypes.default.func,
  htmlName: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func.isRequired,
  onEnterPress: _propTypes.default.func,
  onKeyUp: _propTypes.default.func,
  type: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Input.defaultProps = {
  type: 'text'
};
var _default = Input;
exports.default = _default;